import { oktaConfig as okta } from './okta.config.development';

export const environment = {
  production: false,
  apiUrl: 'https://dntiop-vendorapidev.cbre.com/api/v1',
  fileUploadApiUrl: 'https://dntiop-sharedapidev.cbre.com/api/v1',
  iskillApiUrl: 'https://iskill-dev.cbre.com/api/v1/iskill',
  okta,
};
